module.exports = __webpack_public_path__ + "static/media/roof.56b120e2.png";